//============================================================================================================
//  GLOBAL VARS
//============================================================================================================

var fancyOverlayColor = '#fff';
var fancyOverlayOpacity = 0.75;
var rating = 4.3;

//============================================================================================================
//  DOCUMENT READY
//============================================================================================================
$(document).ready(function () {

    initMyAccountFunctions();
    initCheckoutFunction();

    function initMyAccountFunctions() {
        if (typeof (InitMyAccountFunctions) == "function")
            InitMyAccountFunctions();
    };

    function initCheckoutFunction() {
        if (typeof (InitCheckoutFunctions) == "function")
            InitCheckoutFunctions();
    };

    $('*[data-only-numbers="true"]').keyup(function () {
        var value = this.value.replace(/[^0-9\.,]/g, '');

        if (this.value != value) {
            this.value = value;
        }
    });

    // formatPrices();
    allowOnlyNumbersInput();
    // instagramListOwl();

    showElement($('.img-fade-in:not(.shown),.text-fade-in:not(.shown)'));
    $(window).scroll(function () {
        showElement($('.img-fade-in:not(.shown),.text-fade-in:not(.shown)'));
        fixedScroll();
    });

   
    videosAutoPlay();
    videoPlayPause();
    videoAutoPlayOnPageLoad();
    resetVideo();
    fullScreenPopup();
    scrollToSecondSection();
    formatDate();
    initCustomScrollbar();
    initParseURLForForms();
});

function initParseURLForForms() {
    //get anchor from url
    var formQuery = document.URL.split('#')[1];
    if (formQuery) {
        form = formQuery.split('?')[0];
        if (formQuery.split('?')[1] !== undefined) {
            //prefill form with model
            car = decodeURI(formQuery.split('?')[1].split('&')[0].split('=')[1]);
            code = decodeURI(formQuery.split('?')[1].split('&')[1].split('=')[1]);
            $form = $('#'+form+'');
            formEl = $form.get(0);
            formEl.reset();
            formEl.setCar(car,code);
        }
        $('a[href^="#'+form+'"]')
        .eq(0)
        .click();
    }
}

function initCustomScrollbar() {
    $('.mCustomScrollbar-vertical').mCustomScrollbar({
        axis:"y",
        theme:"dark-3"
    });
    $('.select-wrapper .newList').mCustomScrollbar({
        axis:"y",
        theme:"dark-3"
    });
    $('.mCustomScrollbar-horizontal').mCustomScrollbar({
        axis:"x",
        theme:"dark-3"
    });
}

function showElement(el) {
    $(el).each(function(){
        if (!$(this).hasClass('shown') && isElementInViewport($(this))) {
            $(this).addClass('shown');
        }
    });
}

function fixedScroll() {
    var offset = $('header').height();
    var amount = 1 - ($(window).scrollTop()/$(window).height()) + 0.2;
    if (amount > 1) {
        amount = 1;
    } else if ( amount < 0) {
        amount = 0;
    }
    if (window.pageYOffset > offset) {
        $('.fixed-scroll-element').addClass('fixed');
        $('.fixed-scroll-element .image-container, .fixed-scroll-element .info-container').css({
            opacity: function() {
                return  amount;
            }
          });
        $('.fixed-scroll-element .info-container').css({
        'transform': 'scale(' + amount + ')'
        });
    } else {
        $('.fixed-scroll-element').removeClass('fixed');
    }
}
/**
 * detect IE 9
 * returns version of IE or false, if browser is not Internet Explorer 9
 */
function detectIE() {
    var ua = window.navigator.userAgent;
    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    // other browser
    return false;
}

//============================================================================================================
//  DOCUMENT READY END
//============================================================================================================
function numbersOnly(event) {
	// left arrow, right arrow, tab
	if (event.keyCode == 37 || event.keyCode == 39 || event.keyCode == 9) {
	}
	else if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 36 || event.keyCode == 35) { // delete, backspace, home, end
	}
	else {
		if (event.keyCode < 95) {
			if (event.keyCode < 48 || event.keyCode > 57) // numbers
				event.preventDefault();
		}
		else {
			if (event.keyCode < 96 || event.keyCode > 105) // keypad
				event.preventDefault();
		}
	}
}

function preventSpecialCharacter(e) {
	var shiftPressed = e.shiftKey;
	var keyCode = e.keyCode;

	if (shiftPressed) {
		// In Order: '<', '>', '#', '&', '%', '{', '}'
		if (keyCode == 188 || keyCode == 190 || keyCode == 51 || keyCode == 55 || keyCode == 53 || keyCode == 219 || keyCode == 221)
			e.preventDefault();
	} else {
		// In Order: '/', '[', ']', '/(numPad)', '&', '%'
		if (keyCode == 191 || keyCode == 219 || keyCode == 221 || keyCode == 111)
			e.preventDefault();
	}
};

function phoneGROnly(event) {
	numbersOnly(event);
	if ($(event.currentTarget).val().length > 9)
		// delete, backspace, home, end, left arrow, right arrow, tab
		if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 36 || event.keyCode == 35 || event.keyCode == 37 || event.keyCode == 39 || event.keyCode == 9) { }
		else { event.preventDefault(); }
}

function stickyContainer(container, cssClass) {
    //Sticky container on scroll

    //Call Example
    //stickyContainer($('.header-region'), 'sticky');

    var containerHeight = container.height();
    var scrlTop = $(window).scrollTop();
    container.before("<div class='spacer'></div>");
    var spacer = $('.spacer');

    //Initialize
    if (scrlTop >= containerHeight) {
        spacer.height(containerHeight);
        container.addClass(cssClass);
    }
    else {
        spacer.height(0);
        container.removeClass(cssClass);
    }

    /* respond to scroll event */
    $(window).scroll(function () {
        scrlTop = $(window).scrollTop();
        if (scrlTop >= containerHeight) {
            spacer.height(containerHeight);
            container.addClass(cssClass);
        }
        else {
            spacer.height(0);
            container.removeClass(cssClass);
        }
    });
}

function scroll_to_class(element_class, removed_height) {
    var scroll_to = $(element_class).offset().top - removed_height;
    if ($(window).scrollTop() != scroll_to) {
        $('html, body').stop().animate({
            scrollTop: scroll_to
        }, 0);
    }
}

function saveProductToStorage(id, skuId, path, qty, defaultcolorId, extraAttributes, bundleItems, recipeItems, comboItems, itemInfo) {
    product = {
        id: id,
        skuId: skuId,
        path: path,
        qty: qty,
        defaultcolorId: defaultcolorId,
        extraAttributes: extraAttributes,
        bundleItems: bundleItems,
        recipeItems: recipeItems,
        comboItems: comboItems,
        itemInfo: itemInfo
    };
    Lockr.set('product', product);
}

function notPartOfComboProductsToStorage(id, skuId, path, qty, defaultcolorId, extraAttributes, bundleItems, recipeItems, comboItems, itemInfo) {
    var notPartsOfCombo = Lockr.get('notPartsOfCombo');
    if (notPartsOfCombo === undefined || notPartsOfCombo === null) {
        notPartsOfCombo = [];
    }
    notPartsOfCombo.push({
        id: id,
        skuId: skuId,
        path: path,
        qty: qty,
        defaultcolorId: defaultcolorId,
        extraAttributes: extraAttributes,
        bundleItems: bundleItems,
        recipeItems: recipeItems,
        comboItems: comboItems,
        itemInfo: itemInfo
    });
    Lockr.set('notPartsOfCombo', notPartsOfCombo);
}
function hideOnScrollDown(container, cssClass) {
    // Hide container on on scroll down

    //Call Example
    //hideOnScrollDown($('.header-region'), 'hidden');

    var containerHeight = container.height();

    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;

    $(window).scroll(function (event) {
        didScroll = true;
    });

    setInterval(function () {
        if (didScroll) {
            var st = $(this).scrollTop();
            // Make sure they scroll more than delta
            if (Math.abs(lastScrollTop - st) <= delta)
                return;

            // If they scrolled down and are past the navbar, add class .nav-up.
            // This is necessary so you never see what is "behind" the navbar.
            if (st > lastScrollTop && st > containerHeight) {
                // Scroll Down
                container.addClass(cssClass);
            } else {
                // Scroll Up
                if (st + $(window).height() < $(document).height()) {
                    container.removeClass(cssClass);
                }
            }

            lastScrollTop = st;
            didScroll = false;
        }
    }, 250);

}

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function isTouch() {
    return ($('.touch').length > 0);
}

function importEmailForRegistration() {

    var email = sessionStorage.getItem('registrationEmail');

    if ($('.x-registration-form').length > 0 && email) {
        $('.x-registration-form input[name="email"]').val(email);
    }

    if ($('.x-registration-b2b-form').length > 0 && email) {
        $('.x-registration-b2b-form input[name="email"]').val(email);
    }

}

function initTooltips() {
    var $wrapper = $('.form-row .tooltip-info-wrapper');

    if ($wrapper.length < 1)
        return;

    $('.info-btn', $wrapper).click(function () {
        var tooltipBox = $(this).siblings('.info-tooltip');
        $('.info-tooltip', $wrapper).not(tooltipBox).hide();
        tooltipBox.toggle();
    });

    $(document).on('click', function (e) {
        if (!$wrapper.is(e.target) && $wrapper.has(e.target).length === 0) {
            $('.info-tooltip', $wrapper).hide();
        }
    });
}

function instagramListOwl() {
    if ($('.region-area-instagram').length > 0) {
        var $wrapper = $('.region-area-instagram .instagram-images-list');
        if ($wrapper.length < 1)
            return;
        $('> ul', $wrapper).owlCarousel({
            items: 4,
            navigation: true,
            scrollPerPage: true,
            slideSpeed: 300,
            paginationSpeed: 400,
            itemsDesktopSmall: [979, 3],
            itemsTablet: [768, 2],
            itemsMobile: [479, 2],
        });
        $wrapper.on('click', '.image-container', function (e) {
            e.preventDefault();
            $wrapper.addClass('x-loading');
            var link = 'https://api.instagram.com/oembed?url=' + $(this).data('link');
            $.ajax({
                type: 'GET',
                url: link,
                async: true,
                data: { get_param: 'html' },
                dataType: 'jsonp',
                success: function (data) {
                    var temp = data;
                    $('.fancy-open').trigger("click");
                    $('#fancy-open').html(temp.html);
                    if (typeof window.instgrm !== 'undefined') {
                        window.instgrm.Embeds.process();
                    }
                    $wrapper.removeClass('x-loading');

                }
            });
            $('.fancy-open').fancybox({
                padding: 0,
                maxWidth: 658,
                height: 800,
                fitToView: true,
                autoSize: false,
                afterClose: function () {
                    $('#fancy-open').html('');
                }
            });

        });
    }
}

// in case of pages that need to load inside an iframe
// and call parent vendd js to execute some actions
// make sure that parent vendd iframe is accessible
function getParentOrSelfVendd() {
    try {

        if (typeof parent.Vendd != "undefined")
            return parent.Vendd;
    }
    catch (error) { }

    return Vendd;
}

function scrollTo(whereToScroll) {
    if (whereToScroll.length > 0) {
        topOffset = 0;
        topOffset = whereToScroll.offset().top;
        $('html, body').animate({ scrollTop: topOffset }, 1000);
    }
}

function isElementInViewport (el) {

    if (el.length < 1)
        return;
    //special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom - (rect.height/2) <= (window.innerHeight || document.documentElement.clientHeight)  /*or $(window).height() */
        // rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
    );
}

function fullScreenPopup() {
    var $fancyButton = $('.full-screen-popup, a[href^="#bookTestDrive"], a[href^="#bookService"], a[href^="#requestQuote"], a[href^="#contactForm"]');

    if (!$fancyButton.length > 0)
        return;

    $fancyButton.each(function (i, el) {
        //if href has query attributes, save them to separate data attributes and rewrite href so fancybox doesn't return an error
        if ($(el).attr('href') !== undefined &&
            $(el).attr('href').split('?')[1] !== undefined &&
            $(el).attr('href').split('?')[1].split('&')[1] !== undefined) {
            $(el).attr('data-car',decodeURI($(el).attr('href').split('?')[1].split('&')[0].split('=')[1]));
            $(el).attr('data-code',decodeURI($(el).attr('href').split('?')[1].split('&')[1].split('=')[1]));
            $(el).attr('href',$(el).attr('href').split('?')[0]);
        }else if($(el).attr('href') !== undefined ){
            $(el).attr('href',$(el).attr('href').split('?')[0]);
        }
    });
    $fancyButton.fancybox({
        nextEffect: 'fade',
        prevEffect: 'fade',
        nextSpeed: 300,
        prevSpeed: 300,
        loop  : true,
        btnTpl: {
            smallBtn: '<a title="Close" data-fancybox-close class="fancybox-button fancybox-close-small fancybox-close icon-exit2 stylish-fancy-close" href="javascript:;"></a>',
            arrowLeft: '<a data-fancybox-prev class="fancybox-button fancybox-button--arrow_left icon-arrow-light-left" title="{{PREV}}" href="javascript:;"></a>',
            arrowRight: '<a data-fancybox-next class="fancybox-button fancybox-button--arrow_right icon-arrow-light-right" title="{{NEXT}}" href="javascript:;"></a>'
        },
        touch: false,
        infobar: false,
        baseClass: "full-height",
        beforeLoad: function () {
            car = this.opts.$orig[0].dataset.car;
            code = this.opts.$orig[0].dataset.code;
            formId = this.opts.$orig.attr('data-src') || this.opts.$orig.attr('href');
            if (this.opts.$orig[0].dataset.hideselect) {
                //Hide select box in case of used car (product)
                hideSelect = this.opts.$orig[0].dataset.hideselect;
            }else {
                hideSelect = false;
            }
            $form = $(formId+''); 
            form = $form.get(0);
            if (typeof reset === 'function') {
                form.reset();
            }
            //prefill form with model
            if (car !== undefined && code !== undefined ) {
                form.setCar(car,code,hideSelect);
            }
        },
        afterLoad: function () {
        },
        afterClose: function () {
            //Reset the form
            formId = this.opts.$orig.attr('data-src') || this.opts.$orig.attr('href');
            $form = $(formId+'');
            form = $form.get(0);
            if (typeof form.reset === "function") {

                form.reset();
            }
        }
    });
}

function scrollToSecondSection() {
    var $nextSectionBtn = $(".next-section-btn");

    $nextSectionBtn.on("click", function () {
        scrollTo($('section').eq(1));
    });
  }

function formatDate() {
    var $dates = $('[data-format="date"]');
	$dates.each(function (index, dateContainer) {
        var $date = $(dateContainer), date = $date.html(), formed = "";
        formed = date.replace(/-/g,'/');
		$date.html(formed);
	});
}

function videosAutoPlay() {
    $('.has-video').mouseenter(function () {
        $('.info-container', $(this)).addClass('hide');
        $('video', $(this)).get(0).play();

    });
    $('.has-video').mouseleave(function () {
        $('.info-container', $(this)).removeClass('hide');
        $('video', $(this)).get(0).pause();
    });
}

function videoPlayPause() {
    $('.js-play-video').on('click', function(){
        $wrapper = $(this).parents('.header');
        $video = $wrapper.find('video').get(0);
        if ($video.paused) {
            $video.play();
            $('.info-container, .button', $wrapper).addClass('hide')
        } else {
            $video.pause();
            $('.info-container, .button', $wrapper).removeClass('hide')
        }
    })
    
}

function videoAutoPlayOnPageLoad() {
    var $autoplay = $('.pageload-autoplay');

    if ($autoplay.length < 1)
        return;

    setTimeout(function () {
        $('.js-play-video', $autoplay).trigger("click");
    }, 1000);
    
}

function resetVideo() {
    $('video').on('ended', function () {
        $(this).siblings('.info-container').removeClass('hide');
        $(this).siblings('.button').removeClass('hide');
    });
}
